import { Attribute } from "./models/attributes";
import { SyncMessage } from "./models/synchronizer";
import { User } from "./models/index";
import { SyncCommandLike } from "./models/syncCommand";

export type DexieTable = Dexie.Table<any, any>;

export abstract class BaseDatabase extends Dexie
{
    public Attribute: Dexie.Table<Attribute, string>;
    public SyncMessage: Dexie.Table<SyncMessage, number>;
    public SyncCommand: Dexie.Table<SyncCommandLike, number>;
    public User: Dexie.Table<User, number>;

    constructor(name: string)
    {
        super(name);
        this.version(1).stores({
            Attribute: 'key',
            SyncMessage: '++id,timestamp',
            SyncCommand: 'id',
            User: 'id',
        });
    }
}